// Types
import { RootState } from 'types/RootState.types';

export const getLoginApiCallActiveSelector = (state: RootState) => state.login?.apiCallActive || false;
export const getLoginShowEmailValidationErrorSelector = (state: RootState) =>
  state.login?.showEmailValidationError || false;
export const getLoginPageCompleteSelector = (state: RootState) => state.login?.getLoginPageComplete ?? false;
